// TODO: This file was created by bulk-decaffeinate.
// Sanity-check the conversion and remove this comment.
// TODO -- refactor this to be reused for the inbox selector in the conversation header


import classnames from 'classnames'

import DropDown from 'components/DropDown'
import InboxDropdown from './InboxDropdown'

import 'styles/components/InboxButton'

const InboxButton = React.createClass({
  displayName: 'InboxButton',
  mixins: [require('react-onclickoutside')],

  getInitialState() { return { showInboxDropdown: false } },

  render() {
    return (
      <div className="InboxButton">
        <button
          className={classnames({ selected: this.state.showInboxDropdown })}
          onClick={this.handleOnClick}>
          <div>
            {this.props.selectedInbox != null ? this.props.selectedInbox.name : undefined}
          </div>
          <img src={require('images/down-arrow-circle.svg')} />
        </button>
        {this.state.showInboxDropdown ?
          <DropDown className="inbox-dropdown" onClickOutside={this.handleClickOutside}>
            <InboxDropdown
              inboxes={this.props.inboxes}
              onSelectInbox={this.props.onSelectInbox}
              onClickOutside={this.handleClickOutside} />
          </DropDown> : undefined}
      </div>
    )
  },

  handleClickOutside() {
    return this.setState({ showInboxDropdown: false })
  },

  handleOnClick() {
    return this.setState({ showInboxDropdown: !this.state.showInboxDropdown })
  }
})

export default InboxButton



// WEBPACK FOOTER //
// ./src/scripts/components/conversation/InboxButton.js